import React from 'react'

const BlockquoteBorderColorFont = () => {
    return (
        <div className="col-xl-12">
            <div className="card h-100 p-0">
                <div className="card-header border-bottom bg-base py-16 px-24">
                    <h6 className="text-lg fw-semibold mb-0">Blockquote Border Color</h6>
                </div>
                <div className="card-body p-24">
                    <div className="row gy-4">
                        <div className="col-lg-4 col-sm-6">
                            <div className="p-16 bg-transparent radius-8 border border-start-width-3-px border-cyan">
                                <h6 className="text-primary-light text-md mb-8">
                                    Custom Blockquote Primary Example
                                </h6>
                                <span className="text-cyan mb-0">- WowDash</span>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="p-16 bg-transparent radius-8 border border-start-width-3-px border-success-main">
                                <h6 className="text-primary-light text-md mb-8">
                                    Custom Blockquote Primary Example
                                </h6>
                                <span className="text-success mb-0">- WowDash</span>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="p-16 bg-transparent radius-8 border border-start-width-3-px border-info-main">
                                <h6 className="text-primary-light text-md mb-8">
                                    Custom Blockquote Primary Example
                                </h6>
                                <span className="text-info-main mb-0">- WowDash</span>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="p-16 bg-transparent radius-8 border border-start-width-3-px border-danger-main">
                                <h6 className="text-primary-light text-md mb-8">
                                    Custom Blockquote Primary Example
                                </h6>
                                <span className="text-danger-main mb-0">- WowDash</span>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="p-16 bg-transparent radius-8 border border-start-width-3-px border-warning-main">
                                <h6 className="text-primary-light text-md mb-8">
                                    Custom Blockquote Primary Example
                                </h6>
                                <span className="text-warning-main mb-0">- WowDash</span>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="p-16 bg-transparent radius-8 border border-start-width-3-px border-neutral-600">
                                <h6 className="text-primary-light text-md mb-8">
                                    Custom Blockquote Primary Example
                                </h6>
                                <span className="text-primary-light mb-0">- WowDash</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlockquoteBorderColorFont